import { ChangeDetectorRef, Injector } from "@angular/core";
import { AppConsts } from "@shared/AppConsts";
import { LocalizationService } from "@abp/localization/localization.service";
import { PermissionCheckerService } from "@abp/auth/permission-checker.service";
import { FeatureCheckerService } from "@abp/features/feature-checker.service";
import { NotifyService } from "@abp/notify/notify.service";
import { SettingService } from "@abp/settings/setting.service";
import { MessageService } from "@abp/message/message.service";
import { AbpMultiTenancyService } from "@abp/multi-tenancy/abp-multi-tenancy.service";
import { AppSessionService } from "@shared/common/session/app-session.service";
import { PrimengDatatableHelper } from "shared/helpers/PrimengDatatableHelper";
import { AppUiCustomizationService } from "@shared/common/ui/app-ui-customization.service";
import { UtilsService } from "@abp/utils/utils.service";
import { TenantListDto } from "@shared/service-proxies/service-proxies";
export abstract class AppComponentBase {
    localizationSourceName =
        AppConsts.localization.defaultLocalizationSourceName;

    localization: LocalizationService;
    permission: PermissionCheckerService;
    feature: FeatureCheckerService;
    notify: NotifyService;
    setting: SettingService;
    message: MessageService;
    multiTenancy: AbpMultiTenancyService;
    appSession: AppSessionService;
    primengDatatableHelper: PrimengDatatableHelper;
    ui: AppUiCustomizationService;
    tenantName: string;
    _utilesService: UtilsService;
    versionText: string;
    //_dectRef:ChangeDetectorRef
    constructor(injector: Injector) {
        this.localization = injector.get(LocalizationService);
        this.permission = injector.get(PermissionCheckerService);
        this.feature = injector.get(FeatureCheckerService);
        this.notify = injector.get(NotifyService);
        this.setting = injector.get(SettingService);
        this.message = injector.get(MessageService);
        this.multiTenancy = injector.get(AbpMultiTenancyService);
        this.appSession = injector.get(AppSessionService);
        this.ui = injector.get(AppUiCustomizationService);
        this.primengDatatableHelper = new PrimengDatatableHelper();
        this._utilesService = injector.get(UtilsService);
        // this._dectRef=  injector.get(ChangeDetectorRef)
        this.versionText = this.appSession.application.version;
    }

    truncate4(value: number): string {
        return (Math.trunc(value * 10000) / 10000).toFixed(4);
    }

    isHaveQtyPermission(): boolean {
        if (this.permission.isGranted("Pages.BackOffice.ShowQty")) {
            return true;
        }
        return false;
    }

    isHasPermission(permissionName: string): boolean {
        if (this.permission.isGranted(permissionName)) {
            return true;
        }
        return false;
    }

    l(key: string, ...args: any[]): string {
        return this.ls(this.localizationSourceName, key, args);
    }

    ls(sourcename: string, key: string, ...args: any[]): string {
        let localizedText = this.localization.localize(key, sourcename);

        if (!localizedText) {
            localizedText = key;
        }

        if (!args || !args.length) {
            return localizedText;
        }

        args[0].unshift(localizedText);

        return abp.utils.formatString.apply(this, args[0]);
    }

    isGranted(permissionName: string): boolean {
        return this.permission.isGranted(permissionName);
    }

    isGrantedAny(...permissions: string[]): boolean {
        if (!permissions) {
            return false;
        }

        for (const permission of permissions) {
            if (this.isGranted(permission)) {
                return true;
            }
        }

        return false;
    }

    s(key: string): string {
        return abp.setting.get(key);
    }

    getTenantInfo(): TenantListDto {
        let tenantInfoString: string = this._utilesService.getCookieValue(
            AppConsts.appSessionItems.tenantInfo,
        );

        let tenantInfoModel: TenantListDto = JSON.parse(tenantInfoString);
        return tenantInfoModel;
    }

    setTenantName() {
        let tenantInfo = this.getTenantInfo();
        if (tenantInfo) {
            this.tenantName = tenantInfo.tenancyName;
            //this._dectRef.detectChanges();
        }
    }

    chechSelectAllOption(items, selectedIds: number[]) {
        return selectedIds;
    }

    filterSelectAllList(items: number[]) {
        if (!items || items.length <= 0) return items;

        return items.filter((x) => x !== -1);
    }
}



// WEBPACK FOOTER //
// ./src/shared/common/app-component-base.ts